<template>
    <div class="list-container">
        <editable-list v-if="data"
                       :data="data"
                       :template="template"
                       @save-parent="save"/>
    </div>
</template>

<script>
	import ProductService from "../services/ProductService";
	import ListMixin from "../mixins/ListMixin";

	export default {
		name: "Products",
		mixins: [ListMixin],
		data() {
			return {
				template: {
					_id: "",
                    id: "",
                    name: "",
                    icon: "widgets",
                    image: "",
                    markdown: "",
                    full_name: ""
				},
				backend: ProductService
			};
		}
	}
</script>

<style scoped lang="scss">
    .list-container {
        display: flex;
        position: relative;
        flex-direction: row;
        height: 100vh;
        overflow-y: hidden;
    }
</style>